import {constantRoutes} from '../../router/';
import {platformcode} from "@/store/getters";

export const SET_LOGIN = (state, data) => {
    state.isLogin = data;
    localStorage.setItem('Authorization', data);
};

export const SET_USERINFO = (state, data) => {
    state.userInfo.userguid = data.userguid;
    state.userInfo.name = data.name;
    state.userInfo.avatar = data.avatar;
    state.userInfo.account = data.account;
    state.userInfo.phone = data.phone;
    state.userInfo.isVip = data.isVip;
    state.userInfo.vips = data.vips;
    state.userInfo.isMaster = data.isMaster;
    state.userInfo.collection = data.collection;
    state.userInfo.resources = data.resources;
    state.userInfo.todayEarnings = data.todayEarnings;
    state.userInfo.cumulativeIncome = data.cumulativeIncome;
    state.userInfo.accountBalance = data.accountBalance;
    state.userInfo.materialNum = data.materialNum;
};

export const SET_ROUTES = (state, routes) => {
    state.addRouters = routes;
    state.routes = constantRoutes.concat(routes);
};

export const SET_MEMBERSHIP_DIALOG = (state, data) => {
    state.membershipDialog = data;
};

export const SET_MATERIAL_DETAIL_DIALOG = (state, data) => {
    state.materialDetailDialog = data;
};

export const SEt_PLATFORM = (state, data) => {
    state.platform = data;
}